import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const fillRatioOver98PercentSoftRule: StowageRuleBM = {
    id: StowageRuleId.FillRatioOver98PercentSoftRule,
    name: 'Fill ratio should not exceed 98%',
    lastUpdatedUtc: '2024-07-23T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content volume',
                            fieldPath: 'getTankContentVolume',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Tank volume at 98% filling',
                            fieldPath: 'tank.volumeAt98Percent',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Fill ratio over 98%',
    },
};
